import React from 'react';
import './blog-post.css';
import appsNoms1 from './pictures/appsNoms1.png';

//import reportWebVitals from './reportWebVitals';

const APPSNOMS23 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>2023-24 Officer Applications and Nominations Now Open!</h2>
                    <p class="site-post-meta">April 25, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        Hi WiC members! 
                        <br></br>
                        Would you like to make an impact on gender diversity in computing? Do you like event-planning and being involved
                        in your community? Then you should run for a WiC officer position for 2023-24! Being a WiC officer allows you to 
                        help shape the role that Women in Computing has at UW, gain leadership experience, and generally have a fun time.
                        <br></br>
                        Read about the eight officer positions: <a href="https://tinyurl.com/wic-officers">tinyurl.com/wic-officers</a>
                        <br></br>
                        Apply to run here: <a href="https://tinyurl.com/wic-application">tinyurl.com/wic-application</a>
                        <br></br>
                        <br></br>
                        <br></br>
                        Applications are due at 11:59 pm on May 5th.
                        <br></br>
                        <br></br>
                        If you know someone who is passionate about gender diversity in tech, nominate them to be an officer! Our 
                        anonymous nomination form is here: <a href="https://tinyurl.com/wic-nomination">tinyurl.com/wic-nomination</a>. 
                        Please send nominations by May 2 to give nominees 
                        time to apply.
                        <br></br>
                        <br></br>
                        Note that no previous leadership experience is required (except for the position of Chair) and we welcome students
                        of all gender identities to apply.
                        <br></br>
                        <br></br>
                        If you have any questions about elections, please email us at <a
                        href="mailto:wic-officers@cs.washington.edu">wic-officers@cs.washington.edu</a>. 
                        <br></br>
                        <br></br>
                        We look forward to seeing you all run :) 
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        Best, 
                        <br></br>
                        <br></br>
                        WiC
                    </p>
                    <img src={appsNoms1} alt="Women in Computing, 23-24 Officer Application 
                    and Nominations Applications close May fifth at eleven fifty nine now open!"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default APPSNOMS23;